/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-08 15:56:28
 * @Description: 
 */
import React from "react";
import { IconArrawRight, IconSuccess } from "src/assets";
import "./EffectListCollapseItem.scss"
import urls from "src/constant/url";
import clsx from "clsx";
import FTImageStore from "src/store/FTImageStore";
import FTAnalytic from "src/analyze/FTAnalytic";
import utils from "src/utils";
interface Iprops {
  effect: any;
  active: boolean;
  needCollapse: boolean
}
export default function EffectListCollapseItem(props: Iprops) {
  let { effect, active , needCollapse = true} = props

  const handleChooseEffect = () => {
    
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: utils.toFixed(effect.id, 0),
        resource_name: effect.name,
        boolean1: FTImageStore.searchText !== "" && FTImageStore.selectEffectTags.length === 0,
        boolean2: FTImageStore.selectEffectTags.length !== 0
      }
    })
    FTImageStore.getGoartEffect(effect)
  }
  return <div className={clsx("effect_collapse_item", active && "active", needCollapse && effect.name.replace(/ /g, () => "_"))} onClick={handleChooseEffect}>
    <div className="effect_collapse_item_image">
      <img src={urls.assetsUrl + effect.url} alt={effect.name} />
      {<div className={clsx("effect_collapse_item_check")}>
        <IconSuccess />
      </div>}
    </div>
    <span className="effect_collapse_item_title">{ effect.name}</span>
</div>
}